<template>
  <ServicePageLayout
    title="Energy Analysis"
    subtitle="วิเคราะห์คุณภาพไฟฟ้า"
    icon="mdi-chart-line"
    breadcrumb="Reports"
  >
    <v-row>
      <v-col cols="12" md="4"><DAILY_POWER_QUALITY /></v-col>
      <v-col cols="12" md="4"><WEEKLY_POWER_QUALITY /></v-col>
      <v-col cols="12" md="4"><MONTHLY_POWER_QUALITY /></v-col>
    </v-row>
  </ServicePageLayout>
</template>

<script>
import DAILY_POWER_QUALITY from '@/components/energy_analysis/daily_power_quality'
import MONTHLY_POWER_QUALITY from '@/components/energy_analysis/monthly_power_quality'
import WEEKLY_POWER_QUALITY from '@/components/energy_analysis/weekly_power_quality'
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'

export default {
  name: 'EnergyAnalysisView',
  components: {
    ServicePageLayout,
    DAILY_POWER_QUALITY,
    MONTHLY_POWER_QUALITY,
    WEEKLY_POWER_QUALITY
  },
}
</script>
